exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-item-confirm-textarea[data-v-9a1691f0] {\n  white-space: pre-line;\n  word-break: break-all;\n}\n", ""]);

// exports
